var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-picker"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,class:{'data-item':true, 'data-item-true': _vm.selectIndex == index},on:{"click":function($event){return _vm.pickItemChange(index, item)}}},[_vm._v(_vm._s(_vm.titleKey ? item[`${_vm.titleKey}`] : item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }